import React, { useState, useEffect } from "react";
import {
  FirstSectionWrapper,
  SectionContainer,
  Rowwrapper,
  Colwrapper,
  StyledButton,
} from "../../pages/subcomponents";
import { Subtitles, Title, TitleWrapper } from "../../typography";
import { Typewriter } from "react-simple-typewriter";
import github from "../../assesets/github.png";
import { trackSocialClick } from "../../utils/analytics";
import meduim from "../../assesets/meduim.png";
import linkedin from "../../assesets/linkedin.png";
import instagram from "../../assesets/instagram.png";
import gmail from "../../assesets/gmail.png";
import whatsapp from "../../assesets/whatsapp.png";
import monitor from "../../assesets/Code typing-bro.png";
import monitor_no_color from "../../assesets/Code typing-bro-nocolor.png";

const Hero = (): React.ReactElement => {
  const [image, setImage] = useState(monitor_no_color);
  const [query450, setQuery450] = useState<MediaQueryList | null>(null);
  const [query768, setQuery768] = useState<MediaQueryList | null>(null);

  useEffect(() => {
    if (typeof window !== "undefined") {
      const mediaQuery450 = window.matchMedia("(max-width: 550px)");
      const mediaQuery768 = window.matchMedia("(max-width: 768px)");
      setQuery450(mediaQuery450);
      setQuery768(mediaQuery768);

      const handleResize450 = (e: MediaQueryListEvent) => {
        setQuery450(e.target as MediaQueryList);
      };

      const handleResize768 = (e: MediaQueryListEvent) => {
        setQuery768(e.target as MediaQueryList);
      };

      mediaQuery450.addEventListener("change", handleResize450);
      mediaQuery768.addEventListener("change", handleResize768);

      return () => {
        mediaQuery450.removeEventListener("change", handleResize450);
        mediaQuery768.removeEventListener("change", handleResize768);
      };
    }
  }, []);

  return (
    <>
      <FirstSectionWrapper
        id="home"
        onMouseEnter={() => {
          setImage(monitor);
        }}
        onMouseLeave={() => {
          setImage(monitor_no_color);
        }}
      >
        <SectionContainer>
          <Rowwrapper>
            <Colwrapper lg={8} xl={7} xs={12}>
              <TitleWrapper
                textAlign={query768?.matches ? "center" : "start"}
                alignItems={query768?.matches ? "center" : "start"}
              >
                <Subtitles
                  fontFamily={`Montserrat, sans-serif`}
                  font={
                    query450?.matches
                      ? "12px"
                      : query768?.matches
                        ? "13px"
                        : "14px"
                  }
                  color="#c4cfde"
                  letterSpacing={
                    query450?.matches
                      ? "1.5px"
                      : query768?.matches
                        ? "2px"
                        : "3px"
                  }
                  fontWeight={500}
                >
                  WELCOME TO MY WORLD
                </Subtitles>
                <Title
                  fontFamily={`Montserrat, sans-serif`}
                  font={
                    query450?.matches
                      ? "1.75rem"
                      : query768?.matches
                        ? "2.2rem"
                        : "50px"
                  }
                  lineHeight={query768?.matches ? "1.3" : "1.2"}
                  color="#fff"
                  letterSpacing={
                    query450?.matches
                      ? "1px"
                      : query768?.matches
                        ? "2px"
                        : "3px"
                  }
                  fontWeight={700}
                  className="mt-2"
                  aria-label="Introduction: Hi, I'm Manojkumar"
                  style={{
                    display: "flex",
                    flexWrap: "wrap",
                    justifyContent: query768?.matches ? "center" : "flex-start",
                    alignItems: "center",
                    gap: query450?.matches
                      ? "5px"
                      : query768?.matches
                        ? "8px"
                        : "10px",
                  }}
                >
                  Hi, I'm{" "}
                  <span
                    style={{
                      color: "#ff014f",
                      marginLeft: query450?.matches
                        ? "5px"
                        : query768?.matches
                          ? "10px"
                          : "15px",
                    }}
                    aria-label="Manojkumar"
                  >
                    Manojkumar
                  </span>
                </Title>
                <Title
                  fontFamily={`Montserrat, sans-serif`}
                  font={
                    query450?.matches
                      ? "1.75rem"
                      : query768?.matches
                        ? "2.2rem"
                        : "50px"
                  }
                  lineHeight={query768?.matches ? "1.3" : "1.2"}
                  color="#fff"
                  letterSpacing={
                    query450?.matches
                      ? "1px"
                      : query768?.matches
                        ? "2px"
                        : "3px"
                  }
                  fontWeight={700}
                  aria-label="Role: a developer"
                  style={{
                    display: "flex",
                    flexWrap: "wrap",
                    justifyContent: query768?.matches ? "center" : "flex-start",
                    alignItems: "center",
                    gap: query450?.matches
                      ? "5px"
                      : query768?.matches
                        ? "8px"
                        : "10px",
                    marginTop: "5px",
                  }}
                >
                  a
                  <div
                    style={{
                      marginLeft: query450?.matches
                        ? "5px"
                        : query768?.matches
                          ? "10px"
                          : "15px",
                    }}
                    aria-live="polite"
                    aria-atomic="true"
                  >
                    <Typewriter
                      words={[
                        "React Developer",
                        "Frontend Developer",
                        "Backend Developer",
                        "Freelancer",
                      ]}
                      loop
                      cursor
                      cursorColor="#ff014f"
                      cursorStyle="_"
                      typeSpeed={70}
                      deleteSpeed={50}
                      delaySpeed={1000}
                    />
                  </div>
                </Title>
                <Subtitles
                  fontFamily={`Montserrat, sans-serif`}
                  font={
                    query450?.matches
                      ? "14px"
                      : query768?.matches
                        ? "15px"
                        : "16px"
                  }
                  lineHeight={query768?.matches ? "1.6" : "30px"}
                  color="#c4cfde"
                  fontWeight={500}
                  className="mt-4"
                  style={{
                    textAlign: query768?.matches ? "center" : "left",
                    maxWidth: "100%",
                    justifyContent: query768?.matches ? "center" : "flex-start",
                  }}
                >
                  I'm a software developer with three years of hands-on
                  experience in creating dynamic and innovative web
                  applications. My passion for technology is coupled with a
                  strong foundation in both front-end and back-end development.
                </Subtitles>
                <Subtitles
                  fontFamily={`Montserrat, sans-serif`}
                  font={
                    query450?.matches
                      ? "11px"
                      : query768?.matches
                        ? "12px"
                        : "13px"
                  }
                  lineHeight={query768?.matches ? "1.5" : "30px"}
                  color="#c4cfde"
                  fontWeight={300}
                  letterSpacing={
                    query450?.matches
                      ? "1.5px"
                      : query768?.matches
                        ? "1.8px"
                        : "2px"
                  }
                  style={{
                    marginTop: query450?.matches
                      ? "25px"
                      : query768?.matches
                        ? "30px"
                        : "35px",
                    textAlign: query768?.matches ? "center" : "left",
                    justifyContent: query768?.matches ? "center" : "flex-start",
                  }}
                >
                  FIND ME ON
                </Subtitles>
                <div
                  style={{
                    display: "flex",
                    flexDirection: "row",
                    justifyContent: query768?.matches ? "center" : "flex-start",
                    alignItems: "center",
                    gap: query450?.matches
                      ? "12px"
                      : query768?.matches
                        ? "18px"
                        : "25px",
                    flexWrap: "wrap",
                    marginTop: query450?.matches
                      ? "15px"
                      : query768?.matches
                        ? "18px"
                        : "10px",
                    width: "100%",
                  }}
                >
                  <StyledButton
                    title="Linkedin"
                    onClick={() => {
                      trackSocialClick("linkedin");
                      window.open(
                        "https://www.linkedin.com/in/manojkumar-s-27a084208/",
                        "_blank",
                        "noopener,noreferrer"
                      );
                    }}
                    aria-label="Visit Manojkumar's LinkedIn profile"
                    tabIndex={0}
                  >
                    <img src={linkedin} alt="LinkedIn icon" loading="lazy" />
                  </StyledButton>{" "}
                  <StyledButton
                    title="Github"
                    onClick={() => {
                      trackSocialClick("github");
                      window.open(
                        "https://github.com/Manojkumar-MK18",
                        "_blank",
                        "noopener,noreferrer"
                      );
                    }}
                    aria-label="Visit Manojkumar's GitHub profile"
                    tabIndex={0}
                  >
                    <img src={github} alt="GitHub icon" loading="lazy" />
                  </StyledButton>{" "}
                  <StyledButton
                    title="Medium"
                    onClick={() => {
                      trackSocialClick("medium");
                      window.open(
                        "https://medium.com/@manojkumar18",
                        "_blank",
                        "noopener,noreferrer"
                      );
                    }}
                    aria-label="Visit Manojkumar's Medium profile"
                    tabIndex={0}
                  >
                    <img src={meduim} alt="Medium icon" loading="lazy" />
                  </StyledButton>{" "}
                  <StyledButton
                    title="Gmail"
                    onClick={() => {
                      trackSocialClick("gmail");
                      window.open(
                        "https://mail.google.com/mail/?view=cm&fs=1&tf=1&to=manojkumar.sekar2000@gmail.com",
                        "_blank",
                        "noopener,noreferrer"
                      );
                    }}
                    aria-label="Send email to Manojkumar"
                    tabIndex={0}
                  >
                    <img src={gmail} alt="Gmail icon" loading="lazy" />
                  </StyledButton>{" "}
                  <StyledButton
                    title="Instagram"
                    onClick={() => {
                      trackSocialClick("instagram");
                      window.open(
                        "https://www.instagram.com/s_mk_m_a_n_o_j/profilecard/?igsh=NGg5cm56d3BseGhz",
                        "_blank",
                        "noopener,noreferrer"
                      );
                    }}
                    aria-label="Visit Manojkumar's Instagram profile"
                    tabIndex={0}
                  >
                    <img src={instagram} alt="Instagram icon" loading="lazy" />
                  </StyledButton>
                  <StyledButton
                    title="WhatsApp"
                    onClick={() => {
                      trackSocialClick("whatsapp");
                      window.open(
                        "https://wa.me/+918825781506",
                        "_blank",
                        "noopener,noreferrer"
                      );
                    }}
                    aria-label="Contact Manojkumar on WhatsApp"
                    tabIndex={0}
                  >
                    <img src={whatsapp} alt="WhatsApp icon" loading="lazy" />
                  </StyledButton>
                </div>
              </TitleWrapper>
            </Colwrapper>
            <Colwrapper
              lg={4}
              xl={5}
              xs={12}
              style={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                marginTop: query768?.matches
                  ? query450?.matches
                    ? "20px"
                    : "30px"
                  : "0",
                marginBottom: query768?.matches ? "20px" : "0",
              }}
            >
              <img
                src={image}
                alt="Developer coding illustration"
                className="banner_1"
                loading="lazy"
                aria-hidden="false"
                style={{
                  maxWidth: query450?.matches
                    ? "85%"
                    : query768?.matches
                      ? "70%"
                      : "100%",
                  height: "auto",
                }}
              />
            </Colwrapper>
          </Rowwrapper>
          <div className="border-bottom-black"></div>
        </SectionContainer>
      </FirstSectionWrapper>
    </>
  );
};

export default Hero;
